import toast from "react-hot-toast";

export const showCustomToast = (message) => {
    toast.custom((t) => (
        <div
          className={`
            ${t.visible ? "animate-custom-enter" : "animate-custom-leave"}
            w-[360px]
            bg-green-50/95
            border border-green-600
            rounded-2xl
            shadow-xl
            pointer-events-auto
            overflow-hidden
          `}
        >
          <div className="flex items-center gap-3 px-4 py-3">
      
            {/* Text */}
            <div className="flex-1 text-right">
              <p className="text-sm font-bold text-green-700">
                مقدار نامعتبر
              </p>
      
              <p className="mt-1 text-xs text-green-600 leading-5">
                حداقل مقدار قهوه آسیاب‌شده ۱۰۰ گرم است.
              </p>
            </div>
      
            {/* Close */}
            <button
              onClick={() => toast.dismiss(t.id)}
              className="
                flex-shrink-0
                text-red-500
                hover:text-red-700
                text-2xl
                leading-none
                transition-colors
              "
              aria-label="بستن"
            >
              ×
            </button>
      
          </div>
        </div>
      ),
      {
        duration: 3000,
      });
};